export default __webpack_public_path__ + "static/landing-image-a-babd4264101a8c1bdb49b5b4020ab6d7.png";